import { Component, EventEmitter, Output, Input } from '@angular/core';
import {Common} from '../../shared/common';

@Component({
  selector: 'voters-list-popup',
  templateUrl: './voters-list-popup.component.html',
  styleUrls: ['./voters-list-popup.component.less', '../../shared/common.less']
})
export class VotersListPopupComponent {
  @Output() endDetailsPopup = new EventEmitter<boolean>();
  @Output() sendDownloadOrder = new EventEmitter<boolean>();
  @Input() mails = [];
  @Input() isAssessors = false;
  @Input() assessors = []
  messageLength = 0

  constructor(public common: Common) {}

  onDismiss(event: boolean) {
    this.endDetailsPopup.emit(event);
  }

  downloadVoterFile() {
    this.sendDownloadOrder.emit(true);
  }

}
